import React from 'react';
import { useNavigate } from 'react-router-dom';
import storelogo from '../../images/playstorelogos.png';

const BottomNav = () => {
  const navigate = useNavigate();

  return (
    <div className="bottomBarContainer">
      <div className="bottomLinks">
        <div className="bottomItem" onClick={() => navigate('/TermsOfUsage')}>Terms of usage</div>
        <div className="bottomItem" onClick={() => navigate('/RefundPolicy')}>Refund Policy</div>
        <div className="bottomItem" onClick={() => navigate('/ShippingAndDelivery')}>Shipping</div>
        <div className="bottomItem" onClick={() => navigate('/PrivacyPolicy')}>Privacy Policy</div>
        <div className="bottomItem" onClick={() => navigate('/Disclaimer')}>Disclaimer</div>
      </div>
      <div className="bottomLogo">
        <img
        src={storelogo}
        useMap="#storemap"
        alt="Download App"
        width="300"
        height="60"
      />
      <map name="storemap">
        <area
          shape="rect"
          coords="0,0,150,60"
          href="https://play.google.com/store/apps/details?id=com.myservicecirclemobile.meritz"
          alt="Google Play"
          target="_blank"
        />
        <area
          shape="rect"
          coords="150,0,300,60"
          href="https://apps.apple.com/us/app/myservicecircle-app/id6745583450"
          alt="App Store"
          target="_blank"
        />
      </map>
      </div>
    </div>
  );
};

export default BottomNav;
